export default {
    SET_OPERATOR: (state, operator) => {
        state.operator = operator;
    }
};
